import {push} from 'react-router-redux';
import * as types from '../constants/ActionTypes';
//import {fetchBooksData, fetchBookData, fetchArticleData} from './data';

export function loginUserSuccess(user) {
   sessionStorage.setItem('sessionUserInfo', JSON.stringify(user));
   return {
      type: types.LOGIN_USER_SUCCESS,
      payload: {
         token: user.token,
         userName: user.userName
      }
   }
}

export function loginUserFailure(error) {
   localStorage.removeItem('userInfo');
   sessionStorage.removeItem('sessionUserInfo');
   if (error.response) {
      return {
         type: types.LOGIN_USER_FAILURE,
         payload: {
            status: error.response.status,
            statusText: error.response.statusText
         }
      }
   }

   return {
      type: types.LOGIN_USER_FAILURE,
      payload: {
         status: 503,
         statusText: 'Service Unavailable'
      }
   }
}

export function loginUserRequest() {
   return {
      type: types.LOGIN_USER_REQUEST
   }
}

export function logout() {
   localStorage.removeItem('userInfo');
   return {
      type: types.LOGOUT_USER
   }
}

export function logoutAndRedirect() {
   return dispatch => {
      dispatch(logout());
      dispatch(push('/login'));
   }
}

export function loginUser(email, password, redirect = "/", savePass) {
   return (dispatch, getState, jsonApi) => {
      dispatch(loginUserRequest());
      return jsonApi.login(email, password)
         .then(response => {
            try {
               dispatch(loginUserSuccess(response));
               if (savePass) {
                  localStorage.setItem('userInfo', JSON.stringify({email: email, password: password}));
               } else {
                  localStorage.removeItem('userInfo');
               }
               if (redirect !== ''){
                  dispatch(push(redirect));
               }
            } catch (e) {
               dispatch(loginUserFailure({
                  response: {
                     status: 403,
                     statusText: 'Invalid token'
                  }
               }));
            }
         })
         .catch(error => {
            dispatch(loginUserFailure(error));
         })
   }
}

export function loginUserThenRunFunc(email, password, savePass, runFunc) {
   return (dispatch, getState, jsonApi) => {
      dispatch(loginUserRequest());
      return jsonApi.login(email, password)
         .then(response => {
            try {
               dispatch(loginUserSuccess(response));
               if (savePass) {
                  localStorage.setItem('userInfo', JSON.stringify({email: email, password: password}));
               } else {
                  localStorage.removeItem('userInfo');
               }

               runFunc(response.token);

            } catch (e) {
               dispatch(loginUserFailure({
                  response: {
                     status: 403,
                     statusText: 'Invalid token'
                  }
               }));
            }
         })
         .catch(error => {
            dispatch(loginUserFailure(error));
         })
   }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js